import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/style.scss'
import { setRem } from '@/utils/rem'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueMeta)

setRem()

new Vue({
  router,
  store,
  metaInfo(){
    if(this.$store.state.metaInfo){
      return {
        title: this.$store.state.metaInfo.title??'Orange Media',
        meta: [
          {
            name: "keywords",
            content: this.$store.state.metaInfo.keywords
          }, {
            name: "description",
            content: this.$store.state.metaInfo.description
          }
        ]
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
